export default __webpack_public_path__ + "images/eaaf91567c39e07f7a1c735db00cc95d-judaism.webp";